import React from 'react'
import { IAuthLayout } from '../../common/types/Auth'

const AuthLayout = (props: IAuthLayout) => {
  return <>{props.children}</>
}

export default AuthLayout
